// prutl-frontend-npm6node14/src/pages/AIInsightManagement.jsx

import React from 'react';
import AIInsightList from '../components/aiInsightManagement/AIInsightList.jsx';

const AIInsightManagement = () => {
  return (
    <div className="aiInsightManagementContainer">
      <h1>AI Insight Management</h1>
      <AIInsightList />
    </div>
  );
};

export default AIInsightManagement;
